import React, {Component} from 'react';
import isMobile from 'ismobilejs';

import Registry from '../../../registry';

import './styles.scss';

import Button from '../UIKit/Button';
import SimpleTextInput from '../UIKit/SimpleTextInput';
import Checkbox from '../UIKit/Checkbox';
import Select from '../UIKit/Select';

class RoomSettings extends Component {
    constructor(props) {
        super(props);
        this.state = {
            mood: '',
            pm_enabled: null,
            mood_visible: null,
            showroom_activated: props.currentRoom.showroom_price > 0
        }
        this.roomNameInputRef = React.createRef();
        this.roomMotdInputRef = React.createRef();
        this.showroomPriceInputRef = React.createRef();
    }

    sendData() {
        const siteInterface = Registry.get('siteInterface');
        siteInterface.setRoomOptions({
            action: "update",
            roomid: this.props.currentRoom.id,
            name: this.roomNameInputRef.current.value(),
//            motd: this.roomMotdInputRef.current.value(),
            showroom_price: this.state.showroom_activated ? this.showroomPriceInputRef.current.value() : 0
        });
        this.props.onSuccess();
    };

    onActivateShowroom(activated) {
        this.setState({showroom_activated: activated});
    }

    render() {
        const lang = Registry.get('locale');

        const {currentUser, currentRoom} = this.props;
        const isAnonymous = currentUser.isAnonymous();
        const isUserFree = !currentUser.isAnonymous() && !currentUser.isXXL();

        const isChrome = /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor);

        return (
            <div className='GeneralOptions RoomSettings'>

                <div className='settings-tab'>
                    <div className="options">
                        <SimpleTextInput ref={this.roomNameInputRef} name="room-name" label={lang.room_name} value={currentRoom.name}/>
                    { /* <SimpleTextInput ref={this.roomMotdInputRef} name="room-motd" label={lang.room_motd} value={currentRoom.motd}/> */ }
                        
                        <Checkbox text={lang.activate_showroom} checked={this.state.showroom_activated} onChange={this.onActivateShowroom.bind(this)}/>
                        {this.state.showroom_activated &&
                            <Select ref={this.showroomPriceInputRef} ux="buttons" label={lang.showroom_price_input} value={currentRoom.showroom_price} options={[{"label" : "1", "key":1, "value": 1},{"label" : "2", "key":2, "value": 2},{"label" : "3", "key":3, "value": 3},{"label" : "4", "key":4, "value": 4},{"label" : "5", "key":5, "value": 5}]}/>
                        }
                    </div>

                    <div className='bottom'>
                        <Button text={lang.apply} default onClick={this.sendData.bind(this)} />
                    </div>
                </div>
            </div>
        );
    }
}

export default RoomSettings;



// WEBPACK FOOTER //
// ./src/components/bobtv-neo/SettingsPopup/RoomSettings.js